/*
 *  Copyright (c) 2021 Cognitran Limited. All Rights Reserved.
 */

$(function () {
    function postMessageEventListener(event) {
        var data = event.data

        if (data.error && data.dialog) {
            var dialogOptions = data.dialog
            function pullOutButtons(buttonsArr) {
                var obj = {}
                for (var index = 0; index < buttonsArr.length; index++) {
                    var element = buttonsArr[index];
                    var label = buttonsArr[index].text;
                    obj[label] = {}

                    // Handle styling
                    if (element.styleVariant) {
                        obj[label].classes = 'btn-' + element.styleVariant
                    }

                    // Handle links on buttons
                    if (element.link && element.link === 'dsc-master') {
                        obj[label].callback = function () {
                            window.top.location.href = $i.contextPath + '/content/document/view?id=' + data.documentId;
                            this.close();
                        }
                    } else {
                        obj[label].callback = function () {
                            this.close();
                        }
                    }

                }
                return obj
            }

            return $i.dialog({
                title: dialogOptions.title,
                body: Array.isArray(dialogOptions.body) ? dialogOptions.body.join(' ') : dialogOptions.body,
                buttons: pullOutButtons(dialogOptions.buttons),
                closeable: false
            });
        }

        if (data.message === 'document-iframe') {
            window.top.location.href = $i.contextPath + '/content/document/dsc/master/list?masterId=' + data.documentId;
        }
    }

    window.addEventListener('message', postMessageEventListener)
});
